import { getSplitLayoutTargetWidth } from './getSplitLayoutTargetWidth';
import { resizePanelTo } from './resizePanelTo';

/**
 * Expands the enclosing Nav 4 panel to its 50% cap, making room for the split layout's right pane.
 * The target overshoots 50% so `resizePanelTo`'s clamp pins it to the real max regardless of side-nav width.
 */
export const expandPanelToSplitLayout = (fromElement: HTMLElement | null): boolean => {
	if (typeof window === 'undefined') {
		return false;
	}
	return resizePanelTo(fromElement, getSplitLayoutTargetWidth());
};
